var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
* Version 2 migrations for the website.
* - Migrate any spacing settings from the parent levels onto the individual widgets.
* - Remove any spacing settings from sections.
*
* EDIT: The original migration here wasn't written correctly, and because of a mix up
* of a feature built after it messing with version numbers, we can't safely run it
* anymore, so just increment the version number.
*/
export default function v2(website) {
    return __assign(__assign({}, website), { frameworkVersion: 2 });
}
